import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Radio,
    Row,
    Select,
    Typography,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTerminationReason } from "../../redux/rtk/features/masters/terminationReasonSlice";
import { addTermination, getAllTermination } from "../../redux/rtk/features/termination/terminationSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
  
  const { TextArea } = Input;
  const { Title } = Typography;
  const { Option } = Select;
  
  const AddTermination = () => {
    const dispatch = useDispatch();
  
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
  
    const staffList = useSelector((state) => state.users?.list);
    const terminationReasons = useSelector((state) => state.terminationReason.termination);
  
    useEffect(() => {
      dispatch(getAllTerminationReason());
      dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);
  
    const handleFormSubmit = (values) => {
      setLoader(true);
      dispatch(addTermination(values))
        .unwrap()
        .then((res) => {
          form.resetFields();
          dispatch(getAllTermination());
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => setLoader(false));
    };
  
    return (
      <Fragment>
        <UserPrivateComponent permission={"create-attendance"}>
          <Row className="mb-4" justify="center">
            <Col span={24}>
              <Form
                form={form}
                style={{ marginBottom: "40px" }}
                eventKey="termination-form"
                name="basic"
                labelCol={{
                  span: 10,
                }}
                wrapperCol={{
                  span: 14,
                }}
                onFinish={handleFormSubmit}
                autoComplete="off"
              >
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Employee"
                  name="userId"
                  rules={[
                    {
                      required: true,
                      message: "Please select an employee!",
                    },
                  ]}
                >
                  <Select placeholder="Select Employee">
                    {staffList?.map((staff) => (
                      <Select.Option key={staff.id} value={staff.id}>
                        {staff.userName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Date"
                  name="terminationDate"
                  rules={[
                    {
                      required: true,
                      message: "Please select termination date!",
                    },
                  ]}
                >
                  <DatePicker format={"YYYY-MM-DD"} style={{ width: "100%" }} />
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Reason"
                  name="reason"
                  rules={[
                    {
                      required: true,
                      message: "Please select termination reason!",
                    },
                  ]}
                >
                  <Select placeholder="Select Reason">
                    {terminationReasons?.map((reason) => (
                      <Select.Option key={reason.id} value={reason.id}>
                        {reason.terminationReason}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Detail"
                  name="detail"
                >
                  <TextArea rows={4} placeholder="Additional termination detail" />
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Exit Interview"
                  name="exitInterviewPerformed"
                >
                  <Radio.Group>
                    <Radio.Button value={true}>Yes</Radio.Button>
                    <Radio.Button value={false}>No</Radio.Button>
                  </Radio.Group>
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Re-employment"
                  name="suitableForReemployment"
                >
                  <Radio.Group>
                    <Radio.Button value={true}>Eligible</Radio.Button>
                    <Radio.Button value={false}>Not Eligible</Radio.Button>
                  </Radio.Group>
                </Form.Item>
  
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  wrapperCol={{
                    offset: 6,
                    span: 18,
                  }}
                >
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    block
                    loading={loader}
                  >
                    Termination
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </UserPrivateComponent>
      </Fragment>
    );
  };
  
  export default AddTermination;